'use strict';

var React = require('react');
require('prop-types');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var classNames = require('classnames');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Typography = require('../../node_modules/@material-ui/core/esm/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = {
  cardStyle: {
    width: '88px',
    height: '104px',
    margin: 'none',
    textAlign: 'center',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: '8px',
    border: '1px solid rgba(0,0,0,.12)',
    '&:hover': {
      border: '1px solid #2196f3'
    }
  },
  cardSelected: {
    border: '1px solid #2196f3',
    color: '#2196f3'
  }
};

function IndustryCard(_ref) {
  var _onClick = _ref.onClick,
      icon = _ref.icon,
      isSelected = _ref.isSelected,
      classes = _ref.classes,
      industry = _ref.industry,
      name = _ref.name;
  return React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.cardStyle, isSelected && classes.cardSelected),
    onClick: function onClick() {
      return _onClick(industry);
    }
  }, React__default["default"].createElement(Grid, {
    container: true,
    spacing: 8,
    justify: "center",
    alignItems: "center"
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, React__default["default"].cloneElement(icon, {
    color: isSelected ? 'primary' : 'secondary'
  })), React__default["default"].createElement(Grid, {
    item: true,
    xs: 11
  }, React__default["default"].createElement(Typography["default"], {
    align: "center",
    variant: "caption",
    color: isSelected ? 'primary' : 'textSecondary'
  }, name))));
}

IndustryCard.defaultProps = {
  industry: {},
  isSelected: false,
  onClick: function onClick() {}
};
var IndustryCard$1 = withStyles(styles)(IndustryCard);

module.exports = IndustryCard$1;
